export default {
    // "sdkappid": 1400345619,
    // "sdkappid": 1400421061,
    "sdkappid": 1400355084,
    // "sdkappid": 1400354736,
    "users": [{
        'userNick': '闫玲玲',
        "userId": "user1",
        role: 1,
        "userToken": "eJyrVgrxCdYrSy1SslIy0jNQ0gHzM1NS80oy0zLBwqXFqUWGUInilOzEgoLMFCUrQxMDA2NTQ0NLA4hMakVBZlEqUNzU1NTIwAAqWpKZCxazsDA1tbQwNoKakpkONNfHJyfVLculNN2r0CgzMtm0MMg5LN9P2ykg2KlEO9s43Kww3cDV0TW7zDjUVqkWABjBMOg_"
    }, {
        'userNick': '吕飞',
        "userId": "user2",
        role: 3,
        "userToken": "eJyrVgrxCdYrSy1SslIy0jNQ0gHzM1NS80oy0zLBwqXFqUVGUInilOzEgoLMFCUrQxMDA2NTQ0NLA4hMakVBZlEqUNzU1NTIwAAqWpKZCxazsDA1NbE0M4KakpkONNerSNvA2dnQPDW9wsXX0dAnIMm5xNC9ItI8zM-DxTfUNL80OzPZzz-Qv8TXVqkWAPuXMJg_"
    }, {
        'userNick': '吕飞3',
        "userId": "user3",
        role: 3,
        "userToken": "eJwtzE0LgkAUheH-MtvCZsa5oUK7dGEKQtGqTTbX4WYTk19F0X9PzOV5Drwfdsj23oANi5j0OFtOmzTeO6po4r7Fxp*PVtdn50izSCjOfRAi5P8HX44aHB0AJOezdmQnCwIAFa7lXCEzduM62wpV5fiOxa09XvLFtTytyjQpdj0VqX2YxA6GrEur54Z9f0w4MlM_"
    }, {
        'userNick': '郑宇',
        "userId": "user4",
        role: 1,
        "userToken": "eJyrVgrxCdYrSy1SslIy0jNQ0gHzM1NS80oy0zLBwqXFqUUmUInilOzEgoLMFCUrQxMDA2NTQ0NLA4hMakVBZlEqUNzU1NTIwAAqWpKZCxazsDA1NbE0M4KakpkONNcl09TQIj8yxyTVOdfUOcovytfDOdLJNUQ7Rj-DL9syN6880CLDPCUtLUY-tdhWqRYAZLoxZA__"
    }

    /*{
        'userNick': '闫玲玲',
        "userId": "user1",
        role: 1,
        "userToken": "eJwtzF0LgjAYhuH-suOQzd6tKXRkIKFJlCcdapvy9jGW2mhE-z1RD5-rgftLyvwcON2RmIQBJatpo9JmwAYnfve6Y8vRq3tlLSoSM6B0DVywaH70x2KnR*ech5TSWQd8TiYjFoEAsVSwHbumPpUqkS6v-c23D2euRSYO*yyVLyc2l111bCAsvE8r2JLfHzF3Mac_"
    }, {
        'userNick': '吕飞',
        "userId": "user2",
        role: 3,
        "userToken": "eJwtzLEOgjAUheF3uauGtNhWS*IGg0FctO7GW8gNAWpBQY3vLgHG853k-8LleA5e1kMEYcBgPW1CW3eU08TP1vpwOVosb84RQsQFYxshFdfzYwdH3o4upQwZY7N2VE2201wLJdRSoWLsYpFhfDKHftBpHWeqSY1KmkqUny3q*yM2neCYrN7XPtvD7w8gPjFU"
    }, {
        'userNick': '吕飞3',
        "userId": "user3",
        role: 3,
        "userToken": "eJyrVgrxCdYrSy1SslIy0jNQ0gHzM1NS80oy0zLBwqXFqUXGUInilOzEgoLMFCUrQxMDA2MTUzNDS4hMakVBZlEqUNzU1NTIwMAAIlqSmQsWs7A0tDQxMzGDmpKZDjTXwN-EKbKkKCfZ19E70yysMMijzMk8M9DEJ8fSMrcqw60g2SXZKyK4OK3c1VapFgAZNjF9"
    }, {
        'userNick': '郑宇',
        "userId": "user4",
        role: 1,
        "userToken": "eJwtzEELgjAYxvHvsnPYZttqggchDVZBQ*nURdiqd2KMTUWIvnuiHp-fA-8vqi5lNBiPEhRHGG3mDdp8OnjCzH0wnq5H0E3tHGiUEIrxjjJOxPKY0YE3kzPGYozxoh20sx0EEZRTvlbgNXUf24yPZzscW-sOzjbZKad9cR8qXQilzM3bWl5L6aXa5yn6-QFdGDHy"
    }*/
    ]
};
